export enum Module {
	Booking = 'booking',
	Crm = 'crm',
}
